export default "__VITE_ASSET__c5135425__"